import { useRef, useEffect } from "react";
import { useFormContext, useFieldArray } from "react-hook-form";

import { Button } from "ui/button";

import { AdobeFontInputController } from "containers/admin/clients/client/theme-page/preview/sub-tabs/fonts/adobe-fonts/adobe-fonts-input-controller";
import { GoogleFontInputController } from "containers/admin/clients/client/theme-page/preview/sub-tabs/fonts/google-fonts/google-font-input-controller";

import { useThemePreviewContext } from "containers/admin/clients/client/theme-page/contexts/theme-preview-context";

import Icons from "assets";

const FontsContentSection = () => {
  const { control } = useFormContext();
  const { isEditMode } = useThemePreviewContext();
  const initialFieldAdded = useRef(false);

  const {
    fields: googleFontsToRender,
    append: handleGoogleFontAdding,
    remove,
  } = useFieldArray({
    name: "fonts.googleFonts",
    control,
  });

  // make sure there is always at least one google font input field
  useEffect(() => {
    if (!initialFieldAdded.current && googleFontsToRender.length === 0) {
      initialFieldAdded.current = true;
      handleGoogleFontAdding({
        value: null,
        label: null,
        appliedToPreview: false,
      });
    }
  }, [googleFontsToRender.length, handleGoogleFontAdding]);

  return (
    <div>
      <AdobeFontInputController />
      <div className="flex flex-col gap-3 mb-5">
        {googleFontsToRender.map((font, fontIndex) => (
          <GoogleFontInputController
            fontIndex={fontIndex}
            key={font.id}
            removeFontFromForm={remove}
            fieldIsNotRemovable={googleFontsToRender.length === 1}
          />
        ))}
      </div>
      <Button
        variant="outlined"
        fullWidth
        size="large"
        disabled={!isEditMode}
        startIcon={<Icons.RoundPlus />}
        onClick={() =>
          handleGoogleFontAdding({
            value: null,
            label: null,
            appliedToPreview: false,
          })
        }>
        Add Google font
      </Button>
    </div>
  );
};

export default FontsContentSection;
